module.exports = __webpack_public_path__ + "img/public/AdminIcons/delete.svg?fc5fd235";